import { useState, useEffect } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { Button, Container, Grid, Stack, Typography, TextField, FormControlLabel, FormLabel, RadioGroup, Radio, Paper } from "@mui/material";
// components
import Page from "src/components/Page";
import axios from "axios";
import { alert } from "src/services/alert";
import { IMG_BASE_URL } from "src/config/constants";
import FormItem from "src/components/form-item/FormItem";

const keys = ["DAYS_IN_ROW", "ACC_RATE"];

export default function PointConfig() {
  const navigate = useNavigate();

  const [items, setItems] = useState([]);

  const [form, setForm] = useState({
    DAYS_IN_ROW: '',
    ACC_RATE: '',
  });

  useEffect(() => {
    axios
      .post(`/system/config/all`, { keys, page: 0, size: 1000 })
      .then((res) => {
        const { code, msg, data } = res.data;
        if (code === 1) {
          setItems(data);
          const map = {};
          data.forEach((d) => {
            map[d.key] = d.value;
          });
          setForm(map);
        } else {
          alert(msg);
        }
      })
      .catch((err) => {});
  }, []);

  function handleIptChange(ki, val) {
    setForm({
      ...form,
      [ki]: val,
    });
  }

  function handleSubmit() {
    // const formData = {
    //   ...form,
    // };

    // return console.log(formData);

    axios
      .post("/system/config/bulkEdit", { form })
      .then((res) => {
        console.log(res);
        const { code, msg, data } = res.data;
        if (code === 1) {
          // navigate(-1, { replace: true });
          alert(msg, 'success');
        } else {
          alert(msg);
        }
      })
      .catch((err) => {
        console.log("添加资讯出错: ", err);
      });
  }

  return (
    <Page title="积分配置">
      <Container maxWidth="2000px">
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            积分配置
          </Typography>
        </Stack>

        <Paper variant="outlined" sx={{ py: 1, pr: 3 }}>
          {items.map((item) => {
            const { name, key, desc } = item;
            return (
              <FormItem labelStyle={{ width: 150 }} title={name} required key={key}>
                <TextField placeholder={desc} autoComplete="off" id={key} value={form[key]} size="small" onChange={(e) => handleIptChange(key, e.target.value)} />
              </FormItem>
            );
          })}

          {/* <FormItem title="logo">
            <Stack direction="row" alignItems="flex-start">
              {!form.cover ? null : <img src={`${IMG_BASE_URL}${form.cover}`} style={{ maxWidth: 200, maxHeight: 200 }} />}
              <Button variant="contained" onClick={() => handleUpload("cover")}>
                上传
              </Button>
            </Stack>
          </FormItem> */}

          {/* <FormItem title="状态" required>
            <RadioGroup row aria-label="gender" name="row-radio-buttons-group" value={form.isShow}>
              <FormControlLabel value={0} control={<Radio />} label="隐藏" onChange={(e) => handleIptChange("isShow", e.target.value)} />
              <FormControlLabel value={1} control={<Radio />} label="显示" onChange={(e) => handleIptChange("isShow", e.target.value)} />
            </RadioGroup>
          </FormItem> */}

          <FormItem labelStyle={{ width: 150 }}>
            <Button variant="contained" type="submit" onClick={handleSubmit}>
              保存
            </Button>
          </FormItem>
        </Paper>
      </Container>
    </Page>
  );
}
